const icons = {
	whiteActivity: '/images/icons/white/activity.svg',
	whiteBookmark: '/images/icons/white/bookmark.svg',
	whiteCreateLargeActive: '/images/icons/white/createLarge.svg',
	whiteCreateLargeOutline: '/images/icons/white/createLargeThin.svg',
	whiteCreateSmall: '/images/icons/white/createSmall.svg',
	whiteCreateOutlineSmall: '/images/icons/white/createSmall.svg',
	whiteDownvote: '/images/icons/white/downVote.svg',
	whiteFeed: '/images/icons/white/feed.svg',
	whiteGrid: '/images/icons/white/grid.svg',
	whiteHeart: '/images/icons/white/heart.svg',
	whiteHomeActive: '/images/icons/white/home.svg',
	whiteHomeOutline: '/images/icons/white/homeOutline.svg',
	whiteImage: '/images/icons/white/image.svg',
	whiteItem: '/images/icons/white/item.svg',
	whiteKit: '/images/icons/white/kit.svg',
	whiteKudos: '/images/icons/white/kudos.svg',
	whiteList: '/images/icons/white/list.svg',
	whiteComments: '/images/icons/white/comments.svg',
	whiteNotificationsActive: '/images/icons/white/message.svg',
	whiteNotificationsNotActive: '/images/icons/white/messageOutline.svg',
	whiteNotificationsDot: '/images/icons/white/messageOutlineNotificationsDot.svg',
	whiteProfileActive: '/images/icons/white/profile.svg',
	whiteProfileOutline: '/images/icons/white/profileOutline.svg',
	whiteSearchActive: '/images/icons/white/search.svg',
	whiteSearchOutline: '/images/icons/white/searchOutline.svg',
	whiteSend: '/images/icons/white/send.svg',
	whiteShare: '/images/icons/white/share.svg',
	whiteTick: '/images/icons/white/tick.svg',
	whiteUpvote: '/images/icons/white/upVote.svg',
	whiteUser: '/images/icons/white/user.svg',
	whiteWeatherCloudy: '/images/icons/white/weatherCloudy.svg',
	whiteWeatherNight: '/images/icons/white/weatherNight.svg',
	whiteWeatherPartCloudy: '/images/icons/white/weatherPartCloudy.svg',
	whiteWeatherRainy: '/images/icons/white/weatherRainy.svg',
	whiteWeatherSnowy: '/images/icons/white/weatherSnowy.svg',
	whiteWeatherStormy: '/images/icons/white/weatherStormy.svg',
	whiteWeatherSunny: '/images/icons/white/weatherSunny.svg',
	whiteWeatherWindy: '/images/icons/white/weatherWindy.svg',
	blackActivity: '/images/icons/black/activity.svg',
	blackBookmark: '/images/icons/black/bookmark.svg',
	blackCreatelarge: '/images/icons/black/createLarge.svg',
	blackCreatesmall: '/images/icons/black/createSmall.svg',
	blackDownvote: '/images/icons/black/downVote.svg',
	blackFeed: '/images/icons/black/feed.svg',
	blackGrid: '/images/icons/black/grid.svg',
	blackHeart: '/images/icons/black/heart.svg',
	blackHome: '/images/icons/black/home.svg',
	blackImage: '/images/icons/black/image.svg',
	blackItem: '/images/icons/black/item.svg',
	blackKit: '/images/icons/black/kit.svg',
	blackKudos: '/images/icons/black/kudos.svg',
	blackList: '/images/icons/black/list.svg',
	blackComments: '/images/icons/black/comments.svg',
	blackNotifications: '/images/icons/black/notifications.svg',
	blackMessageOutline: '/images/icons/black/messageOutline.svg',
	blackProfile: '/images/icons/black/profile.svg',
	blackSearch: '/images/icons/black/search.svg',
	blackSend: '/images/icons/black/send.svg',
	blackShare: '/images/icons/black/share.svg',
	blackTick: '/images/icons/black/tick.svg',
	blackUpvote: '/images/icons/black/upVote.svg',
	blackUser: '/images/icons/black/user.svg',
	blackWeatherCloudy: '/images/icons/black/weatherCloudy.svg',
	blackWeatherNight: '/images/icons/black/weatherNight.svg',
	blackWeatherPartCloudy: '/images/icons/black/weatherPartCloudy.svg',
	blackWeatherRainy: '/images/icons/black/weatherRainy.svg',
	blackWeatherSnowy: '/images/icons/black/weatherSnowy.svg',
	blackWeatherStormy: '/images/icons/black/weatherStormy.svg',
	blackWeatherSunny: '/images/icons/black/weatherSunny.svg',
	blackWeatherWindy: '/images/icons/black/weatherWindy.svg',
	redActivity: '/images/icons/red/activity.svg',
	redBookmark: '/images/icons/red/bookmark.svg',
	redCreatelarge: '/images/icons/red/createLarge.svg',
	redCreatesmall: '/images/icons/red/createSmall.svg',
	redDownvote: '/images/icons/red/downVote.svg',
	redFeed: '/images/icons/red/feed.svg',
	redGrid: '/images/icons/red/grid.svg',
	redHeart: '/images/icons/red/heart.svg',
	redHome: '/images/icons/red/home.svg',
	redImage: '/images/icons/red/image.svg',
	redItem: '/images/icons/red/item.svg',
	redKit: '/images/icons/red/kit.svg',
	redKudos: '/images/icons/red/kudos.svg',
	redList: '/images/icons/red/list.svg',
	redComments: '/images/icons/red/comments.svg',
	redNotifications: '/images/icons/red/notifications.svg',
	redProfile: '/images/icons/red/profile.svg',
	redSearch: '/images/icons/red/search.svg',
	redSend: '/images/icons/red/send.svg',
	redShare: '/images/icons/red/share.svg',
	redTick: '/images/icons/red/tick.svg',
	redUpvote: '/images/icons/red/upVote.svg',
	redUser: '/images/icons/red/user.svg',
	redWeatherCloudy: '/images/icons/red/weatherCloudy.svg',
	redWeatherNight: '/images/icons/red/weatherNight.svg',
	redWeatherPartCloudy: '/images/icons/red/weatherPartCloudy.svg',
	redWeatherRainy: '/images/icons/red/weatherRainy.svg',
	redWeatherSnowy: '/images/icons/red/weatherSnowy.svg',
	redWeatherStormy: '/images/icons/red/weatherStormy.svg',
	redWeatherSunny: '/images/icons/red/weatherSunny.svg',
	redWeatherWindy: '/images/icons/red/weatherWindy.svg',
	brandFacebook: '/images/external/facebook.svg',
	brandInstagram: '/images/external/instagram.svg',
	brandKitfitMade: '/images/logo/kitfit-logo-black-made-with-kitfit.svg',
	brandKitfitShadow: '/images/logo/kitfit-white-dropshadow.svg'
}

export default icons



// WEBPACK FOOTER //
// ./src/enums/icons.js